'use client';

import Script from 'next/script';

import { NEXT_PUBLIC_FACTORS_AI_TOKEN } from '../../env';

/** Injects the Factors AI tracking snippet for intent capture and campaign tracking */
export const FactorsAiScript = () => {
  if (!NEXT_PUBLIC_FACTORS_AI_TOKEN) {
    return null;
  }

  return (
    <>
      {/* biome-ignore lint/correctness/useUniqueElementIds: Next.js Script requires a static id for deduplication */}
      <Script
        id="factors-ai-init"
        strategy="afterInteractive"
        // biome-ignore lint/security/noDangerouslySetInnerHtml: required for inline third-party tracking snippet
        dangerouslySetInnerHTML={{
          __html: `
            window.faitracker=window.faitracker||function(){this.q=[];var t=new CustomEvent("FAITRACKER_QUEUED_EVENT");return this.init=function(t,e,a){this.TOKEN=t,this.INIT_PARAMS=e,this.INIT_CALLBACK=a,window.dispatchEvent(new CustomEvent("FAITRACKER_INIT_EVENT"))},this.call=function(){var e={k:"",a:[]};if(arguments&&arguments.length>=1){for(var a=1;a<arguments.length;a++)e.a.push(arguments[a]);e.k=arguments[0]}this.q.push(e),window.dispatchEvent(t)},this.message=function(){window.addEventListener("message",function(t){"faitracker"===t.data.origin&&this.call("message",t.data.type,t.data.message)})},this.message(),this.init("${NEXT_PUBLIC_FACTORS_AI_TOKEN}",{host:"https://api.factors.ai"}),this}();
          `,
        }}
      />
      {/* biome-ignore lint/correctness/useUniqueElementIds: Next.js Script requires a static id for deduplication */}
      <Script
        id="factors-ai-script"
        strategy="afterInteractive"
        src="https://app.factors.ai/assets/factors.js"
      />
    </>
  );
};
